import { combineReducers } from "redux";
import creditLimitSlice from "./creditLimitSlice";

const provManagementReducer = combineReducers({
	creditLimit: creditLimitSlice,
});

export default provManagementReducer;
